// extracted by mini-css-extract-plugin
export default {"navigation":"MenuList_navigation__reLhm","navigation__id":"MenuList_navigation__id__oMVJV"};